import dayjs from 'dayjs';
import React from 'react';
import { LuCheckCircle, LuHistory } from 'react-icons/lu';
import { OfflineDriveCandidateStatus, OfflineDriveCandidateStatusHistoryData } from 'types';

interface Props {
	offlineDriveCandidateStatusHistory: OfflineDriveCandidateStatusHistoryData[];
}

const OfflineDriveRoundStatusHistory = ({ offlineDriveCandidateStatusHistory }: Props) => {
	if (!offlineDriveCandidateStatusHistory?.length)
		return (
			<div className="text-center text-sm py-5 flex flex-col items-center gap-2 text-gray-500">
				<div className="w-fit h-fit rounded-full bg-gray-50 p-2 border">
					<LuHistory size={30} />
				</div>
				<div className="text-base font-[400]">No status history</div>
			</div>
		);
	return (
		<div className="bg-inherit flex flex-col gap-5 mt-4">
			{offlineDriveCandidateStatusHistory
				?.sort((a, b) => dayjs(b.updatedAt).unix() - dayjs(a.updatedAt).unix())
				?.filter(el => el?.status)
				?.map((feedback, index) => (
					<div key={index} className="pb-[10px] border-b last:border-none border-[#E4E4EB]">
						<div className="flex items-center justify-between flex-wrap">
							<div
								className={`text-base font-[600] text-[#1C1C28] capitalize flex items-center gap-1 ${
									index === 0 ? 'text-green-500' : 'text-[#1C1C28]'
								}`}
							>
								{String(feedback?.status).replace(/_/g, ' ')}{' '}
								{index === 0 ? <LuCheckCircle /> : null}
							</div>
							<div className="text-xs font-[400] text-[#8F90A6]">
								{dayjs(feedback?.updatedAt || '').format('DD MMM, YYYY [at] HH:mm a')}
							</div>
						</div>

						<div className="mt-[8px] text-[#585757] text-sm font-[400]">Updated by {feedback?.updatedBy?.name}</div>
					</div>
				))}
		</div>
	);
};

export default OfflineDriveRoundStatusHistory;
